import dayjs from 'dayjs'

export const formatTimeUntil = (timestamp: string, t: (key: string, options?: Record<string, any>) => string): string => {
  const now = dayjs()
  const target = dayjs(timestamp)

  // Check for invalid dates
  if (!target.isValid()) {
    return t('{{seconds}}s', { seconds: 0 })
  }

  if (target.isBefore(now)) {
    return t('{{seconds}}s', { seconds: 0 })
  }

  const diff = target.diff(now, 'second')

  const days = Math.floor(diff / (24 * 60 * 60))
  const hours = Math.floor((diff % (24 * 60 * 60)) / (60 * 60))
  const minutes = Math.floor((diff % (60 * 60)) / 60)
  const seconds = diff % 60

  if (days > 0) {
    return t('{{days}}d {{hours}}h {{minutes}}m', { days, hours, minutes })
  } else if (hours > 0) {
    return t('{{hours}}h {{minutes}}m', { hours, minutes })
  } else if (minutes > 0) {
    return t('{{minutes}}m {{seconds}}s', { minutes, seconds })
  }

  return t('{{seconds}}s', { seconds })
}
